import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { ChangeLogPipesModule } from '../../../pipes/change-log-pipes.module';
import { ChangeLogStateLicenseComponent } from './change-log-state-license.component';

@NgModule({
  declarations: [ChangeLogStateLicenseComponent],
  imports: [CommonModule, SharedModule, ChangeLogPipesModule],
  exports: [ChangeLogStateLicenseComponent],
})
export class ChangeLogStateLicenseModule {}
